import React from 'react';
import { Content } from './shared';

const UnitedGymMembership = () => (
  <Content>
    Little changes can add up... and come with rewards! Explore the Rally Health program and how you
    can join.
    <ol>
      <li>Visit the UnitedHealthcare website.</li>

      <li>
        Go to Individual & Families {'>'} Member resources {'>'} Healthcare programs {'>'} Rally.
      </li>
    </ol>
  </Content>
);

export default UnitedGymMembership;
